import { faFlag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as CampaignModal from 'components/campaign-modal';
import * as CreateCampaignDialog from 'components/create-campaign-dialog';
import * as ChecklistItem from 'components/onboarding-checklist/onboarding-checklist-item';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface CreateFirstCampaignChecklistItemProps
    extends ChecklistItem.OnboardingChecklistItemProps {}

const CreateFirstCampaignChecklistItem = (props: CreateFirstCampaignChecklistItemProps) => {
    const { newCampaignCreationOverlay = false } = useFlags();
    const { isCompleted } = props;

    return newCampaignCreationOverlay ? (
        <CreateCampaignDialog.Root
            triggerLocation={CreateCampaignDialog.TriggerLocation.OnboardingChecklist}
        >
            <CreateCampaignDialog.Trigger asChild={true}>
                <div>
                    <ChecklistItem.Root
                        icon={<FontAwesomeIcon icon={faFlag} />}
                        isCompleted={isCompleted}
                    >
                        <ChecklistItem.Text className="text-xl">
                            Launch your first campaign
                        </ChecklistItem.Text>
                    </ChecklistItem.Root>
                </div>
            </CreateCampaignDialog.Trigger>
        </CreateCampaignDialog.Root>
    ) : (
        <CampaignModal.Root>
            <CampaignModal.Trigger asChild={true}>
                <div>
                    <ChecklistItem.Root
                        icon={<FontAwesomeIcon icon={faFlag} />}
                        isCompleted={isCompleted}
                    >
                        <ChecklistItem.Text className="text-xl">
                            Launch your first campaign
                        </ChecklistItem.Text>
                    </ChecklistItem.Root>
                </div>
            </CampaignModal.Trigger>
        </CampaignModal.Root>
    );
};

export { CreateFirstCampaignChecklistItem };
